var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z","key":1})]);
}

ArrowBack.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
